import React, { ReactNode } from 'react'
import { ReactComponent as IconNoPermisiion } from 'images/icons/noPermisiion.svg';

import clsx from 'clsx'
import styles from './NoContent.module.scss'

type Props = {
  className?: string
  title?: string
  message?: ReactNode | string
  small?: boolean
}

export default function NoPermission({
  className,
  title,
  message,
  small,
}: Props) {
  return (
    <div className={clsx(
      styles.noContent,
      small && styles.noContent_small,
      className,
    )}
    >
      <IconNoPermisiion className={styles.icon} />
      <h2>{title || 'No content'}</h2>
      <span>{message || 'This user has not published any videos'}</span>
    </div>
  )
}
